import { Component, Input, OnInit } from "@angular/core";
import { User } from "@nousmedis/guard-types/frontend";
import { Router } from "@angular/router";
import { ActionsMenuService } from "../../services/actionsMenu.service";
import { TranslateService } from "@ngx-translate/core";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { UserService } from "app/modules/user/services/user.service";

export enum checkStatus {
    Zero = 0,
    One = 1,
    moreThanOne = 2,
}

@Component({
    selector: "cc-actions-menu",
    templateUrl: "./actions-menu.component.html",
    styleUrls: ["./actions-menu.component.scss"],
})
export class ActionsMenuComponent implements OnInit {
    @Input() clickedItem: string = "";
    @Input() context: string = "";

    events: string[] = [];
    isExpanded: boolean = false;
    toogleIcon = "arrow_right";
    isVisible: boolean = false;
    downloadJsonHref: any;
    user: User;
    inconMenu = "hail";
    sidenavIsExpanded: boolean = false;
    actionsBunttos: any[];
    fascicleButtons: any[];
    checkControl: checkStatus = checkStatus.Zero;

    constructor (
        private actionsService: ActionsMenuService,
        private router: Router,
        translate: TranslateService,
        private auth: AuthModel,
        userSrv: UserService
    ) {}

    ngOnInit(): void {
        this.user = this.auth.getCurrentUser();
        this.setButtons();
        this.expandSideNav();
        this.checkRows();
        this.listenForCheckItem();
    }

    checkRows() {
        this.actionsService.totalRowsChecked.subscribe((totalRows) => {
            this.setListBehaviour(totalRows);
            this.setButtons();
        });
    }

    listenForCheckItem() {
        this.actionsService.activeItem.subscribe((item: string) => {
            this.clickedItem = item;
        });
    }

    expandSideNav() {
        this.actionsService.change.subscribe((isOpen) => {
            this.isExpanded = isOpen;
            if (isOpen) this.toogleIcon = "arrow_left";
            else this.toogleIcon = "arrow_right";
        });
    }

    setListBehaviour(totalRows: number) {
        if (totalRows == 0) this.checkControl = checkStatus.Zero;
        else if (totalRows == 1) this.checkControl = checkStatus.One;
        else this.checkControl = checkStatus.moreThanOne;
    }

    toogleSideNav() {
        this.sidenavIsExpanded = !this.sidenavIsExpanded;
        if (this.inconMenu == "menu") this.inconMenu = "close";
        else this.inconMenu = "menu";
        this.actionsService.toggle();
    }

    goToHome() { this.router.navigate(["//"]); }
    newPageTempalte() { this.router.navigate(["/page-templates/new"]); }

    setButtons() {
        switch (this.context) {
            default:
                this.isVisible = false;
                break;
        }
    }
}
